(function(){
    var fileStore = [];
    var fileOrder = [];

    var getFileStore = function(){
        return fileStore;
    };

    var getFileOrder = function(){
        return fileOrder;
    };

    var setFileStore = function(newFileStore){
        fileStore = newFileStore;
    };

    var checkExistingImages = function(){
        var containers = $(".image-container:not(.gu-mirror)");
        if(containers){
            for (var i=0; i<(containers.length); i++) {
                var button = $(containers[i]).find('button');
                if(!search(fileStore, button.attr('data-id'), 'id')) {
                    button.attr('data-image-index', i + 1);
                    fileStore.push({id: button.attr('data-id')});
                    fileOrder.push({id: button.attr('data-id'), index: (i + 1)});
                }
            }
        }
    };

    var search = function (array, key, prop){
        // Optional, but fallback to key['name'] if not selected
        prop = (typeof prop === 'undefined') ? 'name' : prop;

        for (var i=0; i < array.length; i++) {
            if (array[i][prop] === key) {
                return true;
            }
        }

        return false;
    };

    var showImage = function(file_selector){
        var files = file_selector.files;

        var imageContainer = $("div.image-area");

        var total_of_image_containers = $(".image-container:not(.gu-mirror)").length;

        var number_of_images = files.length;

        var imagePreviewRow = $('<div class="col image-container">' +
            '          <div class="card">' +
            '            <div class="card-image">' +
            '<button type="button" class="btn-floating halfway-fab waves-effect waves-light red" onclick="FileController.removeImage(this)" ><i class="material-icons">clear</i></button>' +
            '              <img>' +
            '            </div>' +
            '          </div>' +
            '        </div>');

        var i;

        for (i=1; i<=(number_of_images); i++) {
            var index = i + total_of_image_containers;

            var file = files[i-1];

            fileStore.push(file);

            fileOrder.push({name:file.name,index:index});

            var newImagePreviewRow = $(imagePreviewRow).clone();
            var button = $(newImagePreviewRow).find('button');

            button.attr('data-image-index', index);
            button.attr('data-image-size', file.size);
            button.attr('data-image-name', file.name);

            newImagePreviewRow.appendTo(imageContainer);

            var imageType = /image.*/;

            if (!file.type.match(imageType)) {
                continue;
            }

            var img = $(newImagePreviewRow.find('img'));

            img.addClass('previewImage');

            var reader = new FileReader();

            reader.onload = (function (aImg) {
                return function (e) {
                    aImg.attr('src', e.target.result);
                };
            })(img);

            reader.readAsDataURL(file);
        }
    };

    var recountImages = function () {
        var containers = $(".image-container:not(.gu-mirror)");
        var total_of_containers = containers.length;
        for (var i = 1; i <= total_of_containers; i++) {
            $(containers[i-1]).find('button').attr('data-image-index', i);

            var filename = $(containers[i-1]).find('button').attr('data-image-name');

            var result;
            /* jshint ignore:start */
            if(filename) {
                result = $.grep(fileOrder, function (e) {
                    return e.name === filename;
                });
            } else {
                var id = $(containers[i-1]).find('button').attr('data-id');
                result = $.grep(fileOrder, function (e) {
                    return e.id === id;
                });
            }
            /* jshint ignore:end */
            if (result.length === 1) {
                result[0].index = i;
            }
        }

    };

    var removeImgOfListing = function (close_button) {
        deleteConfirm(function (close_button) {
            let target = $(close_button).parents('.image-container:not(.gu-mirror)');
            let fileName = $(close_button).attr('data-image-name');
            let id = $(close_button).attr('data-id');
            let listing_id = $(close_button).attr('data-listing-id');
            let fileSize = $(close_button).attr('data-image-size');
            let files = FileController.getFileStore();

            for (var i = 1; i <= files.length; i++) {
                if (fileName) {
                    if (files[i - 1].size === parseInt(fileSize)) {
                        FileController.getFileStore().splice(i - 1, 1);
                        fileOrder.splice(i - 1, 1);
                    }
                } else {
                    if (files[i - 1].id === id) {
                        FileController.getFileStore().splice(i - 1, 1);
                        fileOrder.splice(i - 1, 1);
                        removeFromListing(id,listing_id);
                    }
                }
            }

            target.fadeOut(500, function(){
                $(this).remove();
                FileController.recountImages();
            });
        }, close_button);

    };

    var removeFromListing = function(id,listing_id){
        $.ajax({
            type: 'POST',
            url: $("body").data("base-url") + "ListingFile/delete",
            data: {
                fileId: id,
                listingId: listing_id},
            success: function (responseText) {
                let response = JSON.parse(responseText);

                if (response.status.localeCompare("success") === 0) {
                    const dt = new Date();

                    Materialize.toast('Removed at ' + dt.getHours() + ":" + ('0' + dt.getMinutes()).slice(-2) + " " + (dt.getHours() >= 12 ? "PM" : "AM"), 2000);
                } else {
                    Materialize.toast(response.message);
                }
            }
        });
    };


    var removeImage = function (close_button) {
        deleteConfirm(function (close_button) {
            var target = $(close_button).parents('.image-container:not(.gu-mirror)');
            var fileName = $(close_button).attr('data-image-name');
            var id = $(close_button).attr('data-id');
            var entity_id = $(close_button).attr('data-entity-id');
            var entity = $(close_button).attr('data-entity');
            var fileSize = $(close_button).attr('data-image-size');
            var files = FileController.getFileStore();

            for (var i = 1; i <= files.length; i++) {
                if (fileName) {
                    if (files[i - 1].size === parseInt(fileSize)) {
                        FileController.getFileStore().splice(i - 1, 1);
                        fileOrder.splice(i - 1, 1);
                    }
                } else {
                    if (files[i - 1].id === id) {
                        FileController.getFileStore().splice(i - 1, 1);
                        fileOrder.splice(i - 1, 1);
                        removeFromDatabase(id, entity, entity_id);
                    }
                }
            }

            target.fadeOut(500, function(){
                $(this).remove();
                FileController.recountImages();
            });
        }, close_button);

    };

    var removeFromDatabase = function(id, entity, entity_id){
        $.ajax({
            type: 'POST',
            url: $("body").data("base-url") + "files/delete",
            data: {
                fileId: id,
                entityId: entity_id,
                entityName: entity},
            success: function (responseText) {
                var response = JSON.parse(responseText);

                if (response.status.localeCompare("success") === 0) {
                    var dt = new Date();

                    Materialize.toast('Removed at ' + dt.getHours() + ":" + ('0' + dt.getMinutes()).slice(-2) + " " + (dt.getHours() >= 12 ? "PM" : "AM"), 2000);
                } else {
                    Materialize.toast(response.message);
                }
            }
        });
    };

    var initialize = function(){
        checkExistingImages();
    };

    if(window.FileController === undefined){
        window.FileController = {};
    }

    window.FileController = {
        removeImage: removeImage,
        recountImages: recountImages,
        showImage: showImage,
        getFileStore: getFileStore,
        getFileOrder: getFileOrder,
        setFileStore: setFileStore,
        initialize: initialize,
        removeImgOfListing: removeImgOfListing
    };
})();